import { jsx as _jsx } from "react/jsx-runtime";
import { EXODUS_ASSET_NAME_TO_CHAIN_NATIVE_TOKEN_NAME } from './constants.js';
import AssetIcon from '../asset-icon/index.js';
function ChainIcon({ name, colored = false, size = 24, ...otherProps }) {
    return (_jsx(AssetIcon, { assetName: EXODUS_ASSET_NAME_TO_CHAIN_NATIVE_TOKEN_NAME[name] ?? name, monochrome: !colored, size: size, ...otherProps }));
}
export default ChainIcon;
